import { render, staticRenderFns } from "./ProductListSkeleton.vue?vue&type=template&id=188fa5db&"
import script from "./ProductListSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductListSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports